module.exports = __webpack_public_path__ + "img/20200512_162323.8c6ce6d6.jpg";